import styled from 'styled-components';

import {
  blueSphera,
  greenSp,
  graySphera,
  whiteSphera,
  grayPlaceholder,
  blackSphera,
  neutralBlueGray
} from 'src/utilities/UIStyles/variables/Colors';

import { fadeIn, fadeOut } from 'src/utilities/animations';

export const ModalCompanyDetailInvestPay = styled.section`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  visibility: ${(props) => (props.showModalCompanyDetailInvestPay ? 'visible' : 'hidden')};
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-color: rgb(0, 0, 0, 0.5);
  z-index: 100;
  animation: ${(props) => (props.showModalCompanyDetailInvestPay ? fadeIn : fadeOut)} 0.5s linear;
  transition: all 0.5s;

  > div {
    width: 70%;
    background-color: ${whiteSphera};
    border-radius: 5px;
    padding-top: 1%;
    padding-bottom: 1%;

    > div:nth-child(1) {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      padding-bottom: 2.5%;
      border-bottom: 1px solid #b7bcc7;

      > h3 {
        font-size: 1.5vw;
        color: ${blackSphera};
        width: 90%;
        padding-left: 5%;
      }

      > figure {
        width: 25px;
        height: 25px;
        cursor: pointer;

        > img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div {
      > div:nth-child(1) {
        > h3 {
          font-size: 2vw;
        }

        > figure {
          > img {
          }
        }
      }
    }
  }

  @media (max-width: 600px) {
    > div {
      width: 90%;
      padding-top: 5%;
      padding-bottom: 5%;

      > div:nth-child(1) {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        padding-bottom: 5%;
        border-bottom: 1px solid #b7bcc7;

        > h3 {
          font-size: 4.2vw;
        }

        > figure {
          > img {
          }
        }
      }
    }
  }
`;

export const DetailInvestPay = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2.5% 5%;
  width: 90%;
  margin: 1% auto 2.5% auto;

  > div:nth-child(1) {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-bottom: 5%;

    > button {
      color: ${whiteSphera};
      font-weight: bold;
      font-size: 1.2vw;
      text-align: center;
      width: 55%;
      height: 50px;
      border: none;
      border-radius: 5px;
      background-color: ${(props) => (props.isExpired ? blackSphera : grayPlaceholder)};
      cursor: ${(props) => (props.isExpired ? 'pointer' : 'not-allowed')};
    }
  }

  > div:nth-child(2) {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2.5%;

    > div:nth-child(1),
    > div:nth-child(2) {
      width: 40%;

      > h3 {
        color: ${blackSphera};
        font-size: 1.5vw;
        margin-bottom: 5%;
      }

      > ul {
        list-style: none;

        > li {
          color: ${blackSphera};
          font-size: 1.2vw;
          margin-bottom: 1%;

          > span {
            color: ${greenSp};
            font-weight: bold;
            font-size: 1.2vw;
          }
        }
      }
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div:nth-child(1) {
      > button:nth-child(1) {
        font-size: 1.5vw;
      }

      > button:nth-child(2) {
        font-size: 1.5vw;
      }
    }

    > div:nth-child(2) {
      > div:nth-child(1),
      > div:nth-child(2) {
        width: 50%;
        > h3 {
          font-size: 2vw;
        }
      }
    }
  }

  @media (max-width: 600px) {
    padding: 5% 5% 0 5%;

    > div:nth-child(1) {
      flex-direction: column;

      > button:nth-child(1) {
        font-size: 4.2vw;
        width: 100%;
        margin-bottom: 5%;
      }

      > button:nth-child(2) {
        font-size: 4.2vw;
        width: 100%;
      }
    }

    > div:nth-child(2) {
      flex-direction: column;

      > div:nth-child(1),
      > div:nth-child(2) {
        width: 100%;
        margin-top: 5%;

        > h3 {
          font-size: 4.5vw;
        }

        > ul {
          > li {
            font-size: 4vw;

            > span {
            }
          }
        }
      }
    }

    > div:nth-child(3) {
      > p {
        font-size: 4vw;
      }
    }
  }
`;

export const Recordatory = styled.div`
  > p {
    font-size: 1.3vw;
    font-weight: bold;
    color: ${neutralBlueGray};
  }
`;

export const ExtraInfo = styled.div`
  width: 90%;
  text-align: center;
  > p {
    font-size: 1.3vw;
    font-weight: bold;
    color: ${neutralBlueGray};
  }
`;
